export default "/images/16e314acee3d3561ddcb37694226e331.avif";